import(/* webpackMode: "eager" */ "/github/workspace/src/app/[locale]/travelers/page.tsx");
